import React, { useRef, useEffect, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import 'bootstrap/dist/css/bootstrap.min.css';
import styles from './sellerregispageblock4.module.css';
import { useTranslation } from "react-i18next";

const SignaturePad = ({ onBack, onNext, updateData, formData }) => {
  const sigCanvas = useRef({});
  const [isChecked, setIsChecked] = useState(formData.agreeContract || false);
  const [errorMessage, setErrorMessage] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    if (formData.signatureImage) {
      sigCanvas.current.clear(); 
      sigCanvas.current.fromDataURL(formData.signatureImage);
    }
    setIsChecked(formData.agreeContract || false);
  }, [formData.signatureImage, formData.agreeContract]);

  const clear = () => {
    sigCanvas.current.clear();
    updateData({ signatureImage: null });
  };

  const save = () => {
    const signatureImage = sigCanvas.current.getTrimmedCanvas().toDataURL('image/png');
    updateData({ signatureImage });
  };

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const handleConfirm = () => {
    if (!sigCanvas.current.isEmpty() && isChecked) {
      save();
      onNext();
    } else {
      setErrorMessage(t("fill_all_data"));
    }
  };

  return (
    <div className={styles['block-container']}>
      {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
      <div className="mb-3 row">
        <label htmlFor="signature" className="col-sm-2 col-form-label">
          {t("signature")}
        </label>
        <div className="col-sm-10">
          <div className={styles['signature-pad']}>
            <SignatureCanvas ref={sigCanvas} penColor="black" canvasProps={{ className: styles['sigCanvas'] }} />
          </div>
        </div>
      </div>
      <div>
        <p>{t("please_use_personal_signature")}</p>
      </div>
      <div className="mt-3 d-flex justify-content-end">
        <button className="btn btn-danger me-2" onClick={clear}>
          {t("clear")}
        </button>
        <button className="btn btn-success" onClick={save}>
          {t("save")}
        </button>
      </div>
      <div className="mb-3 row">
        <label htmlFor="contract" className="col-sm-2 col-form-label">
          {t("contract")}
        </label>
        <div className="col-sm-10">
          <a href="#" className="btn btn-link">
            {t("content_contract")}
          </a>
        </div>
      </div>
      <div className="mt-3">
        <input className="form-check-input" type="checkbox" id="flexCheckIndeterminate" checked={isChecked} onChange={handleCheckboxChange} />
        <label className="form-check-label" htmlFor="flexCheckIndeterminate">
          {t("agree_contract_content")}
        </label>
      </div>
      <div className="d-flex justify-content-between">
        <button type="button" className="btn btn-success" onClick={onBack}>
          {t("comeback")}
        </button>
        <div className="d-flex justify-content-between">
          <button type="button" className="btn btn-primary" onClick={handleConfirm}>
            {t("confirm")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignaturePad;
